import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IImportTypeDropdown, IImportTypeState } from "../../../types/importTypes/importTypeInterfaces";

export const initialState: IImportTypeState = {
  importTypeDropdown: []
};

export const importTypeSlice = createSlice({
  name: 'importType',
  initialState,
  reducers: {
    loadingImportTypeDropdown: (state, action: PayloadAction<IImportTypeDropdown[]>) => {
      state.importTypeDropdown = action.payload;
    },
  }
});

export const { loadingImportTypeDropdown } = importTypeSlice.actions;

export default importTypeSlice.reducer;
